<div class="modal-header">
  <h4 class="modal-title">
    {{'waitPopup.title' | translate}}
  </h4>
</div>
<div class="modal-body pt-0">
  <div class="modal-body-inner">
    {{'waitForProServeProjectImportPopup.message' | translate}}
  </div>
</div>
<div class="modal-no-footer-content">
</div>
